/**
 * Time unit associated with the frequency of the bond's coupon payment.
 * tag: 1949
 * @readonly
 * @enum {string} (String)
 */
export enum CouponFrequencyUnit {
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
  /** Hour */
  Hour = 'H',
  /** Minute */
  Minute = 'Min',
  /** Second */
  Second = 'S',
  /** Term */
  Term = 'T',
}
